module.exports = __webpack_public_path__ + "img/wir-programmieren.b8d92577.svg";